import templateStr from 'text!./templates/policy-level-coverages.html';

export default [function () {
    return {
        template: templateStr,
        scope: {
            policy: '='
        },
        link: function link() /* scope, element, attrs*/{}
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/claim/directives/PolicyLevelCoverages.js
// module id = 1429
// module chunks = 0